import * as React from "react";
import { useGetManagersQuery } from "../services/manager.service";
import { Manager } from "../types/users";
import SelectData from "./global/SelectData";

const SelectManager = ({
  onChange,
  sx,
  value,
  label = "Manager",
  error,
  helperText,
}: {
  onChange: (arg?: number) => void;
  sx?: any;
  value: number;
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const {
    data: managers,
    isLoading,
    isFetching,
  } = useGetManagersQuery({
    page: 0,
    pageSize: 100,
    sortField: "first_name",
    sortMode: "asc",
  });

  return (
    <SelectData
      data={managers?.data}
      getOptionLabel={(manager) => `${manager.first_name} ${manager.last_name}` || "?"}
      getOptionValue={(manager) => manager.id}
      value={value}
      onChange={(value) => onChange(value as number)}
      label={label}
      placeholder="Search manager..."
      error={error}
      helperText={helperText}
      isLoading={isLoading}
      isFetching={isFetching}
      sx={sx}
    />
  );
};
export default SelectManager;
